import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';

interface MobileContextType {
  isMobile: boolean;
}

interface Props {
  children: ReactNode;
}

const MOBILE_BREAKPOINT_QUERY = '(max-width: 1068px)';

const MobileContext = createContext<MobileContextType>({ isMobile: false });

const isMobile = (): boolean => {
  const matchesBreakpoint = window.matchMedia(MOBILE_BREAKPOINT_QUERY).matches;
  const isMobileDeviceUA = /Mobi|Android|iPhone|iPod/i.test(
    navigator.userAgent
  );
  return matchesBreakpoint || isMobileDeviceUA;
};

export const MobileProvider: React.FC<Props> = ({ children }) => {
  const [isMobileDevice, setIsMobileDevice] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_BREAKPOINT_QUERY);

    const updateIsMobile = () => setIsMobileDevice(isMobile());
    updateIsMobile();
    mediaQuery.addEventListener('change', updateIsMobile);
  }, []);

  return (
    <MobileContext.Provider value={{ isMobile: isMobileDevice }}>
      {children}
    </MobileContext.Provider>
  );
};

export const useMobile = (): MobileContextType => useContext(MobileContext);
